export default "__VITE_ASSET__ZED0h9F2__"